/** Admin tab: turn the season cards on or off, edit their words, and preview them. */
import { api } from "../api";
import { S, on } from "../state";
import { $, esc, toast } from "../ui";
import { SEASON_CARD_LIMITS, THANKS_COUNT_FROM, fillCard } from "../../shared/constants";
import type { SeasonCardKind, SeasonCards } from "../../shared/types";
import { showSeasonCard } from "../seasoncard";

const SC: { cards: SeasonCards | null; loading: boolean } = { cards: null, loading: false };

async function load() {
  if (SC.loading) return;
  SC.loading = true;
  try {
    SC.cards = (await api<{ cards: SeasonCards }>("/api/season-cards")).cards;
  } catch (e) {
    toast((e as Error).message);
  }
  SC.loading = false;
  const box = $("#sctab");
  if (box) box.innerHTML = body();
}

const INFO: Record<SeasonCardKind, { name: string; when: () => string }> = {
  kickoff: {
    name: "Admissions Season Kick-Off",
    when: () => "Shows once to each PA and SA per school year, the first time they open the site after you turn it on.",
  },
  thanks: {
    name: "Admissions Season Thank-You",
    when: () =>
      `Shows once to each PA and SA this school year, the next time they open the site after you turn it on. People with no points don't get it. With ${THANKS_COUNT_FROM} or more points it says "You helped with N events this season"; under ${THANKS_COUNT_FROM} it just thanks them, with no count.`,
  },
};

function section(k: SeasonCardKind) {
  const c = SC.cards![k];
  const i = INFO[k];
  const L = SEASON_CARD_LIMITS;
  return `<div class="card stack" style="gap:12px">
    <div class="row between wrap" style="gap:8px"><h2>${i.name}</h2><span class="chip ${c.on ? "ok" : ""}">${c.on ? "On" : "Off"}</span></div>
    <p class="muted small" style="margin:-4px 0 0">${i.when()}</p>
    <label class="row" style="gap:10px;cursor:pointer"><input type="checkbox" id="sc-${k}-on" ${c.on ? "checked" : ""} style="width:18px;height:18px"><span>Turned On</span></label>
    <div><label class="fld" for="sc-${k}-title">Title</label><input type="text" id="sc-${k}-title" maxlength="${L.title}" value="${esc(c.title)}"></div>
    <div><label class="fld" for="sc-${k}-message">Message</label><textarea id="sc-${k}-message" maxlength="${L.message}" rows="6">${esc(c.message)}</textarea></div>
    <div><label class="fld" for="sc-${k}-button">Button Label</label><input type="text" id="sc-${k}-button" maxlength="${L.button}" value="${esc(c.button)}"></div>
    <div class="row wrap" style="gap:8px">${
      k === "thanks"
        ? `<button class="btn ghost sm" data-act="sc-preview" data-kind="thanks" data-stat="14">Preview (14 Points)</button><button class="btn ghost sm" data-act="sc-preview" data-kind="thanks" data-stat="0">Preview (Under ${THANKS_COUNT_FROM} Points)</button>`
        : `<button class="btn ghost sm" data-act="sc-preview" data-kind="kickoff">Preview</button>`
    }<button class="btn sm" style="margin-left:auto" data-act="sc-save" data-kind="${k}">Save</button></div>
  </div>`;
}

function body() {
  if (!SC.cards) return '<p class="muted">Loading…</p>';
  return `<p class="muted small" style="margin:0">Type {first} for the person's first name and {year} for the school year (like ${S.me!.schoolYear}-${S.me!.schoolYear + 1}). Previews only show on your screen.</p>${section("kickoff")}${section("thanks")}`;
}

export function cardsTab() {
  if (!SC.cards) void load();
  return `<div class="stack" id="sctab">${body()}</div>`;
}

const val = (k: SeasonCardKind, f: string) => ($(`#sc-${k}-${f}`) as HTMLInputElement).value;

on({
  "sc-preview": (el) => {
    const k = el.dataset.kind as SeasonCardKind;
    const sy = S.me!.schoolYear;
    const first = S.me!.user.first;
    showSeasonCard(
      {
        kind: k,
        title: fillCard(val(k, "title"), first, sy),
        message: fillCard(val(k, "message"), first, sy),
        button: val(k, "button") || "Close",
        stat: k === "thanks" && Number(el.dataset.stat) >= THANKS_COUNT_FROM ? Number(el.dataset.stat) : null,
      },
      true,
    );
  },
  "sc-save": async (el) => {
    const k = el.dataset.kind as SeasonCardKind;
    const onNow = ($(`#sc-${k}-on`) as HTMLInputElement).checked;
    try {
      const r = await api<{ cards: SeasonCards }>("/api/season-cards", {
        method: "PUT",
        body: { [k]: { on: onNow, title: val(k, "title"), message: val(k, "message"), button: val(k, "button") } },
      });
      SC.cards = r.cards;
      $("#sctab")!.innerHTML = body();
      toast(`${INFO[k].name} saved${onNow ? " and turned on" : ""}`);
    } catch (e) {
      toast((e as Error).message);
    }
  },
});
